import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { IconButton, TextField } from "@mui/material";

const ActiveTaskModal = ({
  open,
  handleContinue,
  handleAction,
  //   handleClose,
}) => {
  return (
    <Modal
      open={open}
      // onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={(theme) => ({
          position: "absolute" as "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "640px",
          bgcolor: "background.paper",
          boxShadow: 24,
          padding: "24px",
          borderRadius: "32px",
          [theme.breakpoints.down("sm")]: {
            width: "343px",
            padding: "16px",
            borderRadius: "16px",
          },
        })}
      >
        <Typography
          sx={(theme) => ({
            color: "#1C1C1E",
            fontSize: "20px",
            fontWeight: "600",
            lineHeight: "22px",
            marginTop: "25px",
            marginBottom: "55px",
            textAlign: "center",
          })}
        >
          У вас есть активная заявка, хотите ее продолжить или подать заявку
          заново?
        </Typography>

        <Box
          sx={(theme) => ({
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "12px",
            [theme.breakpoints.down("sm")]: {
              flexDirection: "column",
            },
          })}
        >
          <Button
            sx={(theme) => ({
              padding: "13px 24px",
              backgroundColor: "#F3F3F7",
              color: "#1C1C1E",
              fontSize: "16px",
              fontWeight: "500",
              lineHeight: "24px",

              borderRadius: "10px",
              ":hover": {
                background: "#F3F3F7",
                color: "#1C1C1E",
              },
              [theme.breakpoints.down("sm")]: {
                //   marginTop: '',
                width: "100%",
              },
            })}
            onClick={handleContinue}
            id="continue-btn"
          >
            Продолжить
          </Button>
          <Button
            sx={(theme) => ({
              padding: "13px 24px",
              backgroundColor: "#27AE60",
              color: "#FFF",
              fontSize: "16px",
              fontWeight: "500",
              lineHeight: "24px",

              borderRadius: "10px",
              ":hover": {
                background: "#27AE60",
                color: "#FFF",
              },
              [theme.breakpoints.down("sm")]: {
                //   marginTop: '',
                width: "100%",
              },
            })}
            onClick={handleAction}
            id="resubmit-btn"
          >
            Подать заново
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default ActiveTaskModal;
